import {createSlice} from '@reduxjs/toolkit'

/*
* action: [{
*   icon: '',
*   onPress: () => {},
*   text: ''
* }]
* */

const initialState = {
    value: null,
    timeout: 0,
    type: 'info', // warning || damage || error || ok || offline
    // actions: [{
    //     icon: 'closecircleo',
    //     onPress: () => {},
    //     text: ''
    // }]
}
export const messageReducer = createSlice({
    name: 'message',
    initialState,
    reducers: {
        hideMessage: (state) => void (state.value = null),
        setMessage: (state: any, action) => {
            state.value = action.payload.value
            state.timeout = action.payload.timeout || 0
            state.actions = action.payload.actions || []
            state.type = action.payload.type || initialState.type
        }
    }
})

// Action creators are generated for each case reducer function
export const {
    setMessage,
    hideMessage
} = messageReducer.actions

export default messageReducer.reducer
